module.exports = __webpack_public_path__ + "static/media/Intersect-2.18df56d3.svg";